interface PlanDetails {
    overageRate: number,
    planCredits: number,
}

const roundDownOverageBudget = (overageBudget: number, planDetails: PlanDetails) => {
    // Round down the dollar amount to the closest block of 1000 credits
    return overageBudget - (overageBudget % planDetails.overageRate)
}

const roundDownOverageCredit = (overageCredits: number) => {
    // Round down the credit amount to the closest block of 1000 credits
    return overageCredits - (overageCredits % 1000)
}

const calculateOverageCredits = (overageDollars: number = 0, planDetails: PlanDetails) => {
    // Calculate how many overage credits the user will have
    return Math.floor((overageDollars / planDetails.overageRate) * 1000)
}


const calculateOverageDollars = (overageCredits: number = 0, planDetails: PlanDetails) => {
    // Calculate how many overage dollars the user will have
    return Math.floor((overageCredits / 1000 ) * planDetails.overageRate)
}

export {
    roundDownOverageBudget,
    calculateOverageCredits,
    calculateOverageDollars,
    roundDownOverageCredit,
}

export type { 
    PlanDetails,
 }
